import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

/**
 * Generates a `data-testid` for a subcomponent given the parent's `data-testid` and the child's suffix.
 * @param dataTestId - The parent `data-testid`.
 * @param suffix - The string to be appended to the parent `data-testid` (with a `-` separator).
 * @returns The concatenated `data-testid`
 */
function getSubDataTestId(dataTestId, suffix) {
  if (dataTestId) {
    var _context;
    return _concatInstanceProperty(_context = "".concat(dataTestId, "-")).call(_context, suffix);
  }
  return undefined;
}

export { getSubDataTestId as default };
